export enum InfoCardActionType {
    Internal = 1,
    URL = 2,
}
